module.exports = __webpack_public_path__ + "static/img/icons.64c87e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/images/icon_sets/icons.png
// module id = Ixym
// module chunks = 1